<template>
  <router-view/>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'cases-page',
        props: {},
        data() {
            return {}
        },
        computed: {},
        mounted () {
            this.fetchInitDataIfRequired()
        },
        methods: {
            ...mapActions({
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/cases/CasesPage.vue